var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-upload"},[_c('label',{staticClass:"uploadImgBtn customBtn",class:{ upload: _vm.uploadStatus, icon_only: _vm.icon_only },style:({
      backgroundSize: _vm.uploadProgress + '%',
      width: (_vm.width || _vm.size) + 'px',
      height: (_vm.round ? _vm.size : _vm.size || _vm.height) + 'px',
      padding: _vm.padding ? _vm.padding + 'px !important' : '',
      borderRadius: _vm.borderRadius ? _vm.borderRadius + 'px !important' : '',
    })},[_c('UploadImgIcon'),_c('span',{staticClass:"load f14 fw500",class:{ grid: _vm.format }},[_vm._v(_vm._s(_vm.text)+" "),_c('span',{staticClass:"format"},[_vm._v(_vm._s(_vm.format))])]),_c('input',{staticClass:"fileInput",attrs:{"type":"file","accept":_vm.fileAccept,"multiple":_vm.multiple},on:{"change":_vm.handleFileUpload}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }